import { render, staticRenderFns } from "./FormatoPedidosNew.vue?vue&type=template&id=3fe5c86b&scoped=true"
import script from "./FormatoPedidosNew.vue?vue&type=script&lang=js"
export * from "./FormatoPedidosNew.vue?vue&type=script&lang=js"
import style0 from "./FormatoPedidosNew.vue?vue&type=style&index=0&id=3fe5c86b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe5c86b",
  null
  
)

export default component.exports